import styled from "styled-components";

export const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: stretch;

  @media (max-width: 768px) {
    flex-direction: column;
    min-height: 100vh;
    max-height: 100%;
    overflow-y: scroll;
    background-color: ${({ theme }) => theme.colors.white};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0 73px 20px 73px;

  @media (max-width: 768px) {
    padding: 24px;
    padding-bottom: 53px;
    border-radius: 15px 15px 0 0;
    overflow-y: initial;
  }
`;
